import { defineStore } from 'pinia'

export interface AuthUser {
  id: number
  email: string
  firstName: string
  lastName: string
  isGuest: boolean
  /** Zgoda newsletter (= zgoda e-mail) — wystawiana partnerom (Segmentify) na dataLayer. */
  newsletter: boolean
  /**
   * Data urodzenia (RRRR-MM-DD) i płeć — atrybuty personalizacji wystawiane na
   * dataLayer razem z resztą `user_data`. Opcjonalne, bo klient nie musi ich podać
   * (PrestaShop: birthday '0000-00-00', id_gender 0) — wtedy pole nie leci wcale.
   */
  birthday?: string
  gender?: 'male' | 'female'
}

export const useAuthStore = defineStore('auth', () => {
  const isLoggedIn = ref(false)
  const currentUser = ref<AuthUser | null>(null)
  /**
   * Czy tożsamość jest już ROZSTRZYGNIĘTA (GET /api/store/account/info zwróciło
   * profil albo 401). Do momentu rozstrzygnięcia `currentUser === null` znaczy
   * „jeszcze nie wiem", nie „gość" — analityka nie może wtedy ogłaszać sesji
   * anonimowej (zob. useAnalytics.syncIdentity).
   */
  const isResolved = ref(false)

  function setUser(user: AuthUser | null) {
    currentUser.value = user
    isLoggedIn.value = user !== null && !user.isGuest
  }

  function markResolved() {
    isResolved.value = true
  }

  function clearUser() {
    currentUser.value = null
    isLoggedIn.value = false
  }

  const displayName = computed(() => {
    if (!currentUser.value) return ''
    return `${currentUser.value.firstName} ${currentUser.value.lastName}`.trim()
  })

  return {
    isLoggedIn,
    currentUser,
    isResolved,
    displayName,
    setUser,
    markResolved,
    clearUser,
  }
})
